import React from 'react'
import styled from 'styled-components'
import {JumboHeading} from './text.js'
import {BodyText} from './text.js'
import theme from './theme.js'
import Button from './button.js'
import InfoBar from './footer-footer-info-bar.js'

const Footer = () => {
  const props = {
    id: 'footer'
  }

  const message = `Feel free to reach out if you're a creative rebel with a question/request or a minimalist brand looking to collaborate. (:`
  const url = `https://docs.google.com/forms/d/e/1FAIpQLSdQ-prDHeKXMp4CwKfGHqhDGaf0CdyPzfhj0mcs4Srn51MGfg/viewform`

  return (
    <Section {...props}>
      <Wrap>
        <TextWrap>
          <Headline>Contact</Headline>
          <Copy>{message}</Copy>
          <Buttons>
            <ProductsButton url={url}>Get in Touch</ProductsButton>
          </Buttons>
        </TextWrap>
      </Wrap>
      <InfoBar/>
    </Section>
  )
}

const Section = styled.section`
  background: ${theme.color.grey.lighten};
`

const Wrap = styled.div`
  width: 80rem; 
  max-width: 100%;
  margin: 0 auto;
  padding: ${theme.pad.large} ${theme.pad.small};
`

const TextWrap = styled.div`
`

const Headline = styled(JumboHeading)`
  text-align: center;
`

const Copy = styled(BodyText)`
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
  text-align: center;
  margin-bottom: ${theme.pad.small};
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const ProductsButton = styled(Button)`
`

export default Footer